var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedinPlatform",
    transform: "translate(0 -0.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16801",
    "data-name": "Group 16801",
    transform: "translate(0 0.602)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "var(--mainColor)",
    id: "Path_11550",
    "data-name": "Path 11550",
    d: "M3.285.6A3.132,3.132,0,0,0,0,3.79,3.1,3.1,0,0,0,3.219,6.977,3.33,3.33,0,0,0,5.63,6.05a3.16,3.16,0,0,0,.907-2.274A3.123,3.123,0,0,0,3.285.6Zm1.5,4.556a2.156,2.156,0,0,1-1.561.574,1.887,1.887,0,0,1-2-1.942A1.9,1.9,0,0,1,3.285,1.847,1.9,1.9,0,0,1,5.319,3.791,1.908,1.908,0,0,1,4.781,5.158Z",
    transform: "translate(0 -0.602)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--mainColor)",
    id: "Path_11551",
    "data-name": "Path 11551",
    d: "M1.173,35.763H6.649V15.191H1.173ZM2.391,16.436H5.43V34.517H2.391Z",
    transform: "translate(-0.588 -7.763)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--mainColor)",
    id: "Path_11552",
    "data-name": "Path 11552",
    d: "M29.7,15.191a7.027,7.027,0,0,0-4.995,1.738l-.171-1.738h-6.2V35.762h6.067V24.95a6.48,6.48,0,0,1,.3-1.688c.733-1.613,1.722-1.613,3.219-1.613a3.462,3.462,0,0,1,3.182,3.609v10.5H37.2V24.14C37.2,17.991,33.316,15.191,29.7,15.191Zm6.282,19.327H32.331v-9.26a4.706,4.706,0,0,0-4.4-4.854c-1.53,0-3.264,0-4.325,2.335a7.327,7.327,0,0,0-.414,2.212v9.567h-3.63V16.436h3.875l.249,2.518h1l.179-.294c.406-.669,1.691-2.224,4.842-2.224,3.025,0,6.282,2.411,6.282,7.7Z",
    transform: "translate(-9.205 -7.763)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinPlatform);
export default __webpack_public_path__ + "static/media/linkedinPlatform.af9219bf232f4b092a73191e3cf85b68.svg";
export { ForwardRef as ReactComponent };